import { ButtonGroup, useNavigation } from '@subaio/components'

import { ButtonOutline } from 'components/Buttons'
import { HeaderIconError } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const Error = () => {
	const { onNavigateTo } = useNavigation()
	return (
		<SplashScreen title='An unexpected error has occurred' icon={<HeaderIconError />}>
			<ButtonGroup spaced>
				<ButtonOutline label='Go back' onClick={() => onNavigateTo({ name: 'Home' })} />
			</ButtonGroup>
		</SplashScreen>
	)
}
